import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { LoginComponent } from './login.component';
import { LoginService }   from './login.service';
import { LoginStates }    from './login.states';
import { MessagesModule } from '../../app-lite/messages/messages.module';
import { SharedModule }   from '../../app-lite/shared/shared.module';
import { XeroModule }     from '../xero/xero.module';

@NgModule({
  declarations: [
    LoginComponent
  ],
  entryComponents: [
    LoginComponent
  ],
  imports: [
    MessagesModule,
    SharedModule,
    XeroModule,

    UIRouterModule.forChild({ states: LoginStates })
  ],
  providers: [
    LoginService
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class LoginModule {}
